import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {OptionDialogController} from './option.dialog.component';
import {InputDialogConfig, OptionDialogConfig, OptionDialogType} from './option.dialog';

export class OptionDialogStaticAccessor {

    private static _observer: BehaviorSubject<OptionDialogController> = new BehaviorSubject<OptionDialogController>(undefined);

    static showConfirmDialog(id: string, opts: OptionDialogConfig): Observable<any> {
        opts.type = OptionDialogType.CONFIRM;
        return OptionDialogStaticAccessor.emitOptionDialogShow(id, {opts});
    }

    static showInputDialog(id: string, opts: OptionDialogConfig, inputOpts: InputDialogConfig): Observable<any> {
        opts.type = OptionDialogType.INPUT;
        return OptionDialogStaticAccessor.emitOptionDialogShow(id, {opts, inputOpts} );
    }

    static showMessageDialog(id: string, opts: OptionDialogConfig): Observable<any> {
        opts.type = OptionDialogType.MESSAGE;
        return OptionDialogStaticAccessor.emitOptionDialogShow(id, {opts});
    }

    static onOptionDialogShow(callback: (opts: OptionDialogController) => void): Subscription {
        return this._observer.subscribe((opts: OptionDialogController) => callback(opts));
    }

    private static emitOptionDialogShow(id: string, opts: {opts: OptionDialogConfig, inputOpts?: InputDialogConfig}): Observable<any> {
        return Observable.create(function (observer) {
            OptionDialogStaticAccessor._observer.next({
                id: opts.opts.id || id,
                opts: opts.opts,
                inputOpts: opts.inputOpts,
                onApply: (value?: any) => observer.next(value),
                onCancel: (value?: any) => observer.error(value)
            });
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/option-dialog/option.dialog.accessor.ts